import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import AssetConfig from "components/core/asset/fields-config";
import TestimonialConfig from "segments/desktop/core-components/testimonial/fields-config";
import FullParagraphConfig from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-config";

const { topic, mobileTextAlign, theme, textAlign, buttonConfig, ...restOfParagraphConfig } = FullParagraphConfig.fields;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Carousel Tabs",
  fields: {
    ...ThemeConfig,
    tabs: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tabs",
      maxLimit: 8,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          tabLabel: { type: FIELD_TYPES.GALLERY, label: "Tab Label", translatable: true },
          tabContent: {
            type: FIELD_TYPES.NESTED,
            label: "Tab content",
            fields: {
              asset: {
                type: FIELD_TYPES.NESTED,
                label: "Background asset",
                fields: AssetConfig
              },
              testimonial: {
                type: FIELD_TYPES.NESTED,
                label: "Testimonial",
                fields: {
                  ...TestimonialConfig.fields,
                  button: {
                    type: FIELD_TYPES.NESTED,
                    label: "Button",
                    fields: {
                      buttonText: {
                        type: FIELD_TYPES.TEXT,
                        label: "Button text"
                      },
                      color: {
                        type: FIELD_TYPES.COLOR_PICKER,
                        label: "Button color"
                      },
                      buttonUrl: {
                        type: FIELD_TYPES.TEXT,
                        label: "Button url"
                      }
                    }
                  }
                }
              },
              stats: {
                type: FIELD_TYPES.MULTIPLE_NESTED,
                label: "Stats",
                maxLimit: 4,
                nestedConfig: {
                  type: FIELD_TYPES.NESTED,
                  fields: {
                    ...restOfParagraphConfig,
                    lineColor: {
                      type: FIELD_TYPES.COLOR_PICKER,
                      label: "Line color"
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
